import { render, staticRenderFns } from "./IMViewEmail.vue?vue&type=template&id=953cdd92&scoped=true&lang=pug"
import script from "./IMViewEmail.vue?vue&type=script&lang=js"
export * from "./IMViewEmail.vue?vue&type=script&lang=js"
import style0 from "./IMViewEmail.vue?vue&type=style&index=0&id=953cdd92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953cdd92",
  null
  
)

export default component.exports